import { AxiosResponse } from 'axios';
import { getAxiosSecureInstance } from '../../utilities/AxiosClient';
import { SecurityModel } from '../../models/security/security';
export interface Organization {
  name?: string;
  avatar: string;
  currency?: string;
  id?: string;
  security?: SecurityModel[];
}

export interface OrganizationSetting {
  id?: string;
  organizationId: string;
  type: string;
  content: string;
  authoredBy?: { id: string; name: string };
  creationDate: string;
  modificationDate: string;
  userId?: string;
}

export async function getOrganizationsList(): Promise<AxiosResponse> {
  const orgList = getAxiosSecureInstance().get(`/api/organizations`);
  return orgList;
}

export async function getOrganization(organizationId: string): Promise<AxiosResponse> {
  return getAxiosSecureInstance().get(`/api/organizations/${organizationId}`);
}

export async function getOrganizationSecurity(organizationId: string): Promise<AxiosResponse> {
  return getAxiosSecureInstance().get(`/api/security/organizations/${organizationId}`);
}

export async function postOrganization(formData: FormData): Promise<AxiosResponse> {
  return getAxiosSecureInstance().post(`/api/organizations`, formData);
}

export async function getOrganizationSettings(organizationId: string): Promise<AxiosResponse> {
  return getAxiosSecureInstance().get(`/api/organizations/${organizationId}/settings`);
}

export async function createOrganizationSetting(
  organizationId: string,
  settings: OrganizationSetting,
): Promise<AxiosResponse> {
  return getAxiosSecureInstance().post(`/api/organizations/${organizationId}/settings`, settings);
}

export async function updateOrganizationSetting(
  organizationId: string,
  settings: OrganizationSetting,
): Promise<AxiosResponse> {
  return getAxiosSecureInstance().put(`/api/organizations/${organizationId}/settings`, settings);
}

export async function deleteOrganizationSetting(organizationId: string, settingId: string): Promise<AxiosResponse> {
  return getAxiosSecureInstance().delete(`/api/organizations/${organizationId}/settings/${settingId}`);
}

export async function updateOrganization(
  organizationId: string | undefined,
  formData: FormData,
): Promise<AxiosResponse> {
  return getAxiosSecureInstance().put(`/api/organizations/${organizationId}`, formData);
}
